import { useCallback, useRef } from 'react';

const ids: Record<string, number> = {};

const getNextId = (prefix: string) => {
  const id = ids[prefix];
  ids[prefix] = (id ?? 0) + 1;
  return ids[prefix];
};
const useId = (prefix = '') => {
  const id = useRef(`${prefix}-${getNextId(prefix)}`);
  const getId = useCallback(() => {
    return `${prefix}-${getNextId(prefix)}`;
  }, [prefix]);

  return {
    id: id.current,
    getId,
  };
};

export default useId;
